// Search titles (60 characters or fewer, brand included) and meta descriptions
// for every indexable route. Keys have no trailing slash. scripts/prerender.js
// reads the keys of this object to know which routes to prerender, so every
// route that should be indexed must appear here.

export const ROUTE_SEO = {
  "/": {
    title: "E-commerce Account Management & Growth Agency | Orina",
    description:
      "Orina Enterprise manages Amazon, Flipkart, Meesho, quick-commerce, Walmart and Noon seller accounts and builds D2C websites for brands in India, USA and UAE.",
  },
  "/about": {
    title: "About Orina Enterprise | E-commerce Growth Agency, Mumbai",
    description:
      "Orina Enterprise is a Mumbai-based e-commerce agency for marketplace onboarding, account management, ads, listings and websites, serving India, the USA and UAE.",
  },
  "/services": {
    title: "E-commerce Services: Onboarding, Ads & Listings | Orina",
    description:
      "Marketplace account management, seller onboarding, listing optimization, ads, account health and website development, run by one accountable Orina team.",
  },
  "/marketplaces": {
    title: "Sell on Amazon, Flipkart, Meesho, JioMart & AJIO | Orina",
    description:
      "Onboarding and account management for Amazon India, Flipkart, Meesho, JioMart and AJIO: registration, catalogue, ads, returns control and weekly reporting.",
  },
  "/premium-marketplaces": {
    title: "Nykaa, Myntra, AJIO Luxe & Tata CLiQ Onboarding | Orina",
    description:
      "Brand approval, premium catalogue production and growth management for Nykaa, Myntra, AJIO Luxe and Tata CLiQ, India's curated fashion and beauty platforms.",
  },
  "/quick-commerce": {
    title: "Blinkit, Zepto & Instamart Seller Onboarding | Orina",
    description:
      "Quick-commerce vendor onboarding for Blinkit, Zepto and Swiggy Instamart: SKU and pack-size strategy, dark-store inventory planning, pricing and ads.",
  },
  "/web-app-development": {
    title: "E-commerce Website & App Development | Orina Enterprise",
    description:
      "Shopify, WooCommerce and custom React/Next.js store development plus iOS and Android apps, with payments, logistics and marketplace catalogue sync built in.",
  },
  "/crm-solutions": {
    title: "WhatsApp CRM, Worknex & Earn Yatra Solutions | Orina",
    description:
      "WhatsApp CRM, the Worknex workflow tool and the Earn Yatra rewards platform from Orina: lead tracking, automation, customer engagement and team management.",
  },
  "/manpower-solutions": {
    title: "Manpower Solutions: Field & Sales Staffing | Orina",
    description:
      "Field manpower, sales staffing and operations support teams from Orina Enterprise for brands, banks and fintechs across Indian cities.",
  },
  "/google-extractor": {
    title: "Google Business Data Extractor Tool | Orina Enterprise",
    description:
      "Extract business listings from Google by category and city and export them to CSV for sales prospecting. Monthly plans from Rs 499.",
  },
  "/calculators": {
    title: "Amazon, Flipkart & JioMart Profit Calculators | Orina",
    description:
      "Free Amazon seller, Flipkart profit and JioMart fee calculators. Enter price, cost and shipping to estimate fees, net profit and margin per unit.",
  },
  "/tools/marketplace-calculators": {
    title: "Marketplace Fee & Profit Calculators for India | Orina",
    description:
      "Model fees, settlement, profit, margin and ROI for Amazon, Flipkart, Meesho, JioMart, Myntra, AJIO, Nykaa, Tata CLiQ, Blinkit, Zepto and Instamart.",
  },
  "/tools/listing-score": {
    title: "Free Marketplace Listing Score Checker | Orina",
    description:
      "Score an Amazon, Flipkart, Meesho, JioMart, Myntra, AJIO or Nykaa product listing out of 100 and get a list of fixes for titles, images and content.",
  },
  "/sales-events": {
    title: "Marketplace Sale Event Preparation (BBD, GIF) | Orina",
    description:
      "Preparation, execution and post-event analysis for Big Billion Days, Amazon Great Indian Festival, Prime Day and quick-commerce sale days.",
  },
  "/testimonials": {
    title: "Client Testimonials & Results | Orina Enterprise",
    description:
      "What D2C founders and brand teams say about working with Orina Enterprise on Amazon, Flipkart, Meesho, JioMart, Nykaa, Myntra, Blinkit and Zepto.",
  },
  "/blog": {
    title: "E-commerce & Marketplace Growth Blog | Orina Enterprise",
    description:
      "Guides to selling on Amazon, Flipkart, Meesho, JioMart and quick commerce: onboarding steps, listing optimization, ads, sale events and D2C websites.",
  },
  "/faq": {
    title: "E-commerce Agency FAQs: Onboarding, Fees & Ads | Orina",
    description:
      "Answers on marketplace onboarding timelines, documents, pricing, account suspensions, ads management and how working with Orina Enterprise works.",
  },
  "/contact": {
    title: "Contact Orina Enterprise | E-commerce Agency, Mumbai",
    description:
      "Call +91 81789 65407, WhatsApp +91 95949 83478 or email letstalk@orinaenterprise.com. Office in Malad West, Mumbai; serving India, the USA and UAE.",
  },
  "/policy": {
    title: "Privacy Policy & Terms of Service | Orina Enterprise",
    description:
      "How Orina Enterprise collects, uses and protects your information, and the terms that apply when you use this website and our services.",
  },
  "/ecommerce-services-usa": {
    title: "Amazon & Walmart Seller Account Management USA | Orina",
    description:
      "Amazon.com, Walmart Marketplace and Shopify account management for US brands and for Indian brands selling into the USA, run from Mumbai across US hours.",
  },
  "/ecommerce-services-uae": {
    title: "Amazon.ae & Noon Account Management in Dubai, UAE | Orina",
    description:
      "Amazon.ae and Noon seller onboarding, listings, ads and account management for brands in Dubai and the UAE, and for Indian brands expanding to the Gulf.",
  },
  "/services/a-plus-listing-graphics": {
    title: "A+ Content & Listing Graphics Design Services | Orina",
    description:
      "A+ content, product infographics, comparison charts and lifestyle image sets for Amazon, Flipkart and other marketplaces. Mobile-first, 7-10 day turnaround.",
  },
  "/services/ecommerce-video-creation": {
    title: "E-commerce Product Video Creation Services | Orina",
    description:
      "Product demo videos, marketplace listing videos, reels and ad creatives for e-commerce brands, from script and shoot to edit and platform-ready exports.",
  },
  "/services/amazon-seller-account-management": {
    title: "Amazon Seller Account Management Services India | Orina",
    description:
      "Amazon India seller management: Seller Central setup, Brand Registry, listings and A+ content, Sponsored Ads, FBA planning and account health monitoring.",
  },
  "/services/flipkart-seller-account-management": {
    title: "Flipkart Seller Account Management Services | Orina",
    description:
      "Flipkart Seller Hub management: listing rewrites, F-Assured qualification, PLA and PCA ads, returns control and Big Billion Days preparation.",
  },
  "/services/meesho-seller-account-management": {
    title: "Meesho Seller Account Management Services | Orina",
    description:
      "Meesho seller management: catalogue depth planning, reseller-friendly creatives, Meesho Ads, all-in pricing and returns control for margin-positive growth.",
  },
  "/services/jiomart-seller-onboarding": {
    title: "JioMart Seller Onboarding & Account Management | Orina",
    description:
      "JioMart seller registration, catalogue upload, pricing and account management for brands selling on Reliance's online marketplace.",
  },
  "/services/myntra-seller-onboarding": {
    title: "Myntra Seller Onboarding for Fashion Brands | Orina",
    description:
      "Myntra brand onboarding: application and approval support, catalogue and image standards, size charts, pricing and ongoing account management.",
  },
  "/services/ajio-seller-onboarding": {
    title: "AJIO Seller Onboarding for Fashion & Lifestyle | Orina",
    description:
      "AJIO onboarding for fashion and lifestyle brands: application, catalogue production to AJIO standards, pricing and account management after go-live.",
  },
  "/services/nykaa-seller-onboarding": {
    title: "Nykaa Seller Onboarding for Beauty Brands | Orina",
    description:
      "Nykaa onboarding for beauty, wellness and personal-care brands: brand approval, compliance documents, catalogue content and growth management.",
  },
  "/services/tatacliq-seller-onboarding": {
    title: "Tata CLiQ Seller Onboarding & Brand Management | Orina",
    description:
      "Tata CLiQ seller onboarding for authentic and premium brands: application, catalogue and pricing setup, and ongoing account management.",
  },
  "/services/blinkit-seller-onboarding": {
    title: "Blinkit Seller Onboarding & Quick Commerce Growth | Orina",
    description:
      "Blinkit vendor onboarding: SKU and pack-size selection, pricing for impulse buys, dark-store inventory planning, city launches and Blinkit ads.",
  },
  "/services/zepto-seller-onboarding": {
    title: "Zepto Seller Onboarding & Quick Commerce Growth | Orina",
    description:
      "Zepto vendor onboarding: assortment and pack-size planning, pricing, inventory replenishment across dark stores and ads to build sell-through.",
  },
  "/services/instamart-seller-onboarding": {
    title: "Swiggy Instamart Seller Onboarding | Orina Enterprise",
    description:
      "Swiggy Instamart vendor onboarding: listing and pricing setup, inventory planning across dark stores, city expansion and in-app ads.",
  },
};

// Short search titles for blog posts whose full headline is over 60 characters.
export const BLOG_SEO_TITLES = {
  "quick-commerce-growth-india-2026": "Quick Commerce Growth in India: 2026 Playbook | Orina",
  "marketplace-sales-event-strategy": "Marketplace Sale Event Strategy: BBD & Prime Day | Orina",
  "marketplace-ads-festive-growth": "Marketplace Ads for Festive Growth (2026) | Orina",
  "amazon-seller-onboarding-india-2026": "Amazon Seller Onboarding in India: 2026 Guide | Orina",
  "flipkart-seller-guide-2026": "Flipkart Seller Guide: Register, Rank & Win | Orina",
  "jiomart-seller-registration-guide": "JioMart Seller Registration Guide | Orina Enterprise",
  "meesho-seller-mistakes-to-avoid": "7 Meesho Seller Mistakes to Avoid | Orina Enterprise",
  "scale-marketplace-sales-india": "How to Scale Marketplace Sales: 90-Day Plan | Orina",
  "top-ecommerce-service-provider-in-india": "How to Choose an E-commerce Service Provider | Orina",
  "india-ecommerce-sales-events-guide": "India E-commerce Sale Events: Seller Guide | Orina",
  "how-a-website-helps-ecommerce-brands-grow": "How a Website Helps E-commerce Brands Grow | Orina",
  "marketplace-listing-optimization-guide-india": "Marketplace Listing Optimization Guide India | Orina",
  "a-plus-content-and-product-graphics-guide": "A+ Content & Product Listing Graphics Guide | Orina",
};

// Meta descriptions for blog posts whose excerpt is longer than 160 characters.
export const BLOG_SEO_DESCRIPTIONS = {
  "india-ecommerce-sales-events-guide":
    "How sellers prepare for Big Billion Days, Amazon Great Indian Festival, Republic Day and quick-commerce sale days: deals, stock, ads and post-event review.",
  "how-a-website-helps-ecommerce-brands-grow":
    "Marketplaces bring volume; your own website builds the brand, first-party data and repeat revenue. Why Indian D2C brands need both, and what to build.",
  "marketplace-listing-optimization-guide-india":
    "Listing optimization for Amazon, Flipkart, Meesho and JioMart: titles, keywords, bullets, images, A+ Content and the conversion levers that matter.",
  "a-plus-content-and-product-graphics-guide":
    "What A+ Content and listing graphics to make, how they should look on mobile, and how they help shoppers understand products on Amazon and Flipkart.",
};
